import { actionNotifier } from '../components/actionNotice';

/**
 * Create an Axios error handler bound to an axios instance.
 * The returned function can be used directly as the interceptor's error handler.
 * - Shows user-facing messages via actionNotifier
 * - Attaches `userMessage` to the error for programmatic use
 * - Clears Authorization header on 401 when axiosInstance is provided
 */
export function createAxiosErrorHandler(axiosInstance) {
  return function handleAxiosError(error) {
    // If no response, it's likely a network or CORS error
    if (!error || !error.response) {
      actionNotifier.error('Network error. Please check your internet connection.');
      if (error) error.userMessage = 'Network error. Please check your internet connection.';
      throw error;
    }

    const status = error.response.status;
    const apiMessage = (error.response.data && (error.response.data.message || error.response.data.error)) || error.message || '';

    switch (status) {
      case 400:
        actionNotifier.error(apiMessage || 'Bad request. Please check the data you provided.');
        error.userMessage = apiMessage || 'Bad request.';
        break;
      case 401:
        actionNotifier.error(apiMessage || 'Unauthorized. Please login again.');
        // Clear auth header so subsequent requests won't reuse an invalid token
        try {
          if (axiosInstance && axiosInstance.defaults && axiosInstance.defaults.headers && axiosInstance.defaults.headers.common) {
            delete axiosInstance.defaults.headers.common['Authorization'];
          }
        } catch (e) {
          // ignore
        }
        error.userMessage = apiMessage || 'Unauthorized.';
        break;
      case 500:
        actionNotifier.error(apiMessage || 'Server error. Please try again later.');
        error.userMessage = apiMessage || 'Server error.';
        break;
      default:
        actionNotifier.error(apiMessage || 'An unexpected error occurred.');
        error.userMessage = apiMessage || 'An unexpected error occurred.';
    }

    throw error;
  };
}

export default createAxiosErrorHandler;
